module.exports = __webpack_public_path__ + "img/client-updates-app.5eb3278f.jpg";